import {IntermediatePart} from "../../intermediatePart";

export default class Fireplace extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'fireplace';
    this.partName = 'Fireplace';
    this.translateId = "visualizer.fireplace.fireplace";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Fireplace());
  }
}
